export class IFileData { 
    fileName?: string; 
    data: any[];
}